import React, { useState, useEffect, useContext } from 'react'
import { getFooterLinks } from './admin/apiCalls';
import { store, StateProvider } from '../Store';

export default function Footer() {
  const { state, dispatch } = useContext(store);

  const [footerLinks, setFooterLinks] = useState([]);

  useEffect(() => {
    getFooterLinks(setFooterLinks)
  }, []);

  const styleTheme = {
    'footer': `${state?.configData && state.configData.theme}-footer`,
    'footerRRSS': `${state?.configData && state.configData.theme}-footer-rrss`
  }

  return (
    <div className={ "odisea-page-footer " + styleTheme.footer}>
      <div className="odisea-page-footer-text">
        <h2> Síguenos en nuestras redes sociales </h2>
      </div>
      <div className="odisea-page-footer-rrss">
        <ul>
          <li>
              <a href={ footerLinks.filter(item => item.title && item.title === 'FACEBOOK').length > 0 && footerLinks.filter(item => item.title && item.title === 'FACEBOOK')[0]['url'] } target="_blank" rel="noopener noreferrer">
                <span className="fa-stack fa-lg">
                  <i className="fa fa-circle fa-stack-2x odisea-page-footer-rrss-circle"></i>
                  <i className={"fa fa-facebook fa-stack-1x fa odisea-page-footer-rrss-logo " + styleTheme.footerRRSS}></i>
                </span>
              </a>
          </li>
          <li>
              <a href={ footerLinks.filter(item => item.title && item.title === 'TWITTER').length > 0 && footerLinks.filter(item => item.title && item.title === 'TWITTER')[0]['url'] } target="_blank" rel="noopener noreferrer">
                <span className="fa-stack fa-lg">
                  <i className="fa fa-circle fa-stack-2x odisea-page-footer-rrss-circle"></i>
                  <i className={"fa fa-twitter fa-stack-1x fa odisea-page-footer-rrss-logo " + styleTheme.footerRRSS}></i>
                </span>
              </a>
          </li>
          <li>
              <a href={ footerLinks.filter(item => item.title && item.title === 'YOUTUBE').length > 0 && footerLinks.filter(item => item.title && item.title === 'YOUTUBE')[0]['url'] } target="_blank" rel="noopener noreferrer">
                <span className="fa-stack fa-lg">
                  <i className="fa fa-circle fa-stack-2x odisea-page-footer-rrss-circle"></i>
                  <i className={"fa fa-youtube fa-stack-1x fa odisea-page-footer-rrss-logo " + styleTheme.footerRRSS}></i>
                </span>
              </a>
          </li>
          <li>
              <a href={ footerLinks.filter(item => item.title && item.title === 'LINKEDIN').length > 0 && footerLinks.filter(item => item.title && item.title === 'LINKEDIN')[0]['url'] } target="_blank" rel="noopener noreferrer">
                <span className="fa-stack fa-lg">
                  <i className="fa fa-circle fa-stack-2x odisea-page-footer-rrss-circle"></i>
                  <i className={"fa fa-linkedin fa-stack-1x fa odisea-page-footer-rrss-logo " + styleTheme.footerRRSS}></i>
                </span>
              </a>
          </li>
        </ul>
      </div>
    </div>
  )
}
